import { debounce, throttle} from 'lodash'
import {useMainStore, useSnapshotStore} from '@/store'
import {storeToRefs} from "pinia";

export default () => {
  const snapshotStore = useSnapshotStore()
  const mainStore = useMainStore()
  const {undoRedoEvent} = storeToRefs(mainStore)

  // Add historical snapshots (history)
  const addHistorySnapshot = debounce(function() {
    snapshotStore.addSnapshot()
  }, 300, { trailing: true })

  // redo
  const redo = async () => {
    await snapshotStore.reDo()
    undoRedoEvent.value = false
  }

  // revoke
  const undo = async () => {
    await snapshotStore.unDo()
    undoRedoEvent.value = false
  }

  return {
    addHistorySnapshot,
    redo,
    undo,
  }
}
